export default "__VITE_ASSET__CcYqGvcI__"